import { Injectable } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { ValidFileStatus } from 'src/app/_services/CommonServices/fileValidation'

@Injectable({
  providedIn: 'root'
})
export class FileValidationService {
  

  constructor(private fb: FormBuilder) {
    this.uploadForm = this.fb.group({});
  }

  uploadForm: FormGroup;
  selectedFile: File | null = null;
  isMalicious: any;
  forbiddenExtensions = ['.html', '.js', '.svg', '.exe', '.bat', '.php', '.aspx', '.cmd', '.sh', '.xsls', '.xls'];
  suspiciousPatterns = ['<script>', 'eval(', 'javascript:', 'onerror=', 'onload='];
  allowedTypes = ['application/pdf', 'image/jpeg', 'image/png', 'application/msword', 'application/vnd.ms-outlook',
    'application/vnd.openxmlformats-officedocument.wordprocessingml.document'];
  maxSize = 2 * 1024 * 1024; // 2MB

  ValidateFile(selectedFile :File) :ValidFileStatus {
    
    const fileExtension = selectedFile.name.slice(selectedFile.name.lastIndexOf('.')).toLowerCase();
    // Check file extension (extra layer)
    if (this.forbiddenExtensions.includes(fileExtension)) {
      return {
        IsValid: false,
        ErrorMessage: 'This file type is not allowed.'
      };
    }

     if (!this.allowedTypes.includes(selectedFile.type)) {
      return {
        IsValid: false,
        ErrorMessage: 'Invalid file type. Only PDF, JPEG, MSWORD, MS-OUTLOOK and PNG are allowed.'
      };
    }

    // Check file size
    // if (selectedFile.size > this.maxSize) {
    //   return {
    //     IsValid: false,
    //     ErrorMessage: 'File is too large. Max size is 2MB.'
    //   };
    // }
  
    return {
      IsValid: true,
      ErrorMessage: ''
    };
  } 

  ValidateFileContent(content: string): ValidFileStatus {
    this.isMalicious = this.suspiciousPatterns.some(pattern => content.includes(pattern));
    if (this.isMalicious) {
      return {
        IsValid: false,
        ErrorMessage: 'Potential malicious script detected!'
      };
    }
    return {
      IsValid: true,
      ErrorMessage: ''
    };
  }
}